function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
import React from "react";
import { useUIDSeed } from "react-uid";
import { twMerge } from "../../../utils";
import { CallToAction, Heading } from "../../atoms";
import { ArrowRight } from "../../icons";
export var NumberedInfoCard = function(param) {
    var number = param.number, title = param.title, description = param.description, callToActions = param.callToActions, className = param.className;
    var seed = useUIDSeed();
    return /*#__PURE__*/ React.createElement("article", {
        className: twMerge("grid grid-cols-1 grid-flow-row auto-rows-max gap-5", className)
    }, /*#__PURE__*/ React.createElement("p", {
        className: "text-8xl font-heading font-bold text-brand-primary-base leading-normal"
    }, "".concat(number, ".")), /*#__PURE__*/ React.createElement(Heading, {
        as: "h3",
        variant: "h3"
    }, title), !!description && /*#__PURE__*/ React.createElement("div", {
        className: "opacity-60 prose leading-extra"
    }, description), !!(callToActions === null || callToActions === void 0 ? void 0 : callToActions.length) && /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-wrap items-center justify-start -m-3"
    }, callToActions.map(function(action) {
        return /*#__PURE__*/ React.createElement(CallToAction, _extends({}, action, {
            key: seed(action),
            className: "m-3",
            linkVariant: "default",
            icon: /*#__PURE__*/ React.createElement(ArrowRight, null)
        }));
    })));
};

//# sourceMappingURL=NumberedInfoCard.js.map